import db from "../db/database";
import { fetchFromBusinessCentral } from "../utils/businessCentralUtils";
import { isOnline } from "./syncService";

// Servicio para sincronizar Configuración de Grupos de Registro IVA
export const syncSerieNCF = async () => {
    if (!isOnline()) {
        return false;
    }

    try {
        // Obtener datos desde Business Central
        const series = await fetchFromBusinessCentral("NoSeriesLines");

        if (!series || series.length === 0) {
            console.warn("No se encontraron registros de series en Business Central");
            return false;
        }

        // Limpiar tabla antes de insertar 
        await db.serieNCF.clear();

        // Insertar todos los registros
        const seriesRecords = series.map(serie => ({
            ...serie,
            lastModified: new Date()
        }));

        await db.serieNCF.bulkAdd(seriesRecords);

        return true;
    } catch (error) {
        console.error("Error al sincronizar series NCF:", error);
        return false;
    }
};

export const getSerieNCFBySeriesCode = async (seriesCode, cai = "") => {
    try {
        let series = await db.serieNCF
            .where("Series_Code")
            .equals(seriesCode)
            .toArray();

        if (!series || series.length === 0) {
            return null;
        }

        // Si se proporciona CAI, filtrar por él. Es probablemente una factura historica y es muy probable que tenga 
        // un CAI diferente al actual por estar vencido
        if (cai) {
            series = series.filter(serie => serie.No_Autorizacion_CAI === cai); //CAI es unico por cada Series_Code
            if (!series || series.length === 0) {
                return null;
            }
            return series[0];
        }

        // Sort para obtener la serie que no este vencida y que tenga la fecha de caducidad más lejana
        series = series
            .filter(x => x.Open === true)
            .sort((a, b) => b.Fecha_Caducidad.localeCompare(a.Fecha_Caducidad));

        if (!series || series.length === 0) {
            return null;
        }
        return series[0];
    } catch (error) {
        console.error(`Error al obtener serie NCF con Series_Code ${seriesCode}:`, error);
        throw error;
    }
};
